export const getPropertyFallbackImageUrl = () => {
  return '/static/images/image-placeholder-smallDE.png'
}
